import { lazy, Suspense } from 'react';

// AG Grid is lazy-loaded so its (~chunky) bundle only downloads when a page
// that uses a grid actually renders — mirrors how xlsx is code-split.
const AgGridInner = lazy(() => import('./AgGridInner.jsx'));

// Grid-wide defaults. Callers override per-column via colDefs and per-grid via
// the defaultColDef prop (shallow-merged below).
const BASE_COL_DEF = { sortable: true, resizable: true, filter: true, minWidth: 90 };

// Themed, lazy AG Grid wrapper. AG Grid needs an explicit height (it doesn't
// grow with content), so we wrap it in a sized div; pass `height` to override.
// Capture the grid API via the standard onGridReady prop rather than a ref, so
// we don't have to forward a ref through React.lazy/Suspense.
export default function DataGrid({ height = 'calc(100vh - 300px)', defaultColDef, style, ...props }) {
  return (
    <div style={{ height, width: '100%', ...style }}>
      <Suspense fallback={<div style={{ padding: 16, fontSize: 13, color: 'var(--text-muted)' }}>Loading grid…</div>}>
        <AgGridInner defaultColDef={{ ...BASE_COL_DEF, ...defaultColDef }} {...props} />
      </Suspense>
    </div>
  );
}
